import type { TableHeadersType, ICustomToolBar } from '../../../types';

export enum ERecordLength {
  RL15 = 15,
  RL25 = 25,
  RL50 = 50,
  RL100 = 100,
  RL500 = 500,
}

export enum ECellType {
  Feature = 'feature',
  Option = 'option',
  Flag = 'flag',
  Quote = 'quote',
  Reset = 'reset',
  Status = 'status',
  SaveStatus = 'saveStatus',
  Boolean = 'boolean',
  Date = 'date',
  Link = 'link',
}

export enum EDataTableType {
  Features = 'features',
  Product = 'product',
  MultiNumeric = 'multiNumeric',
  AllPropertiesHistory = 'allPropertiesHistory',
  PropertyHistory = 'propertyHistory',
}

export const ExcludeColumnFilters = ['flag', 'reset'];

export const TableField = {
  feature: 'feature',
  option: 'option',
  type: 'type',
  rfq: 'RfQ_',
  flag: 'flag',
  code: 'code',
  country: 'country',
  quote: 'quote',
  status: 'status',
  saveStatus: 'saveStatus',
  isActive: 'isActive',
  name: 'name',
  isLocal: 'isLocal',
  createdOn: 'createdOn',
  modifiedOn: 'modifiedOn',
  createdBy: 'createdBy',
  modifiedBy: 'modifiedBy',
  propertyCode: 'propertyCode',
  associationType: 'associationType',
  featureCode: 'featureCode',
  optionCode: 'optionCode',
  action: 'action',
  oldValue: 'oldValue',
  newValue: 'newValue',
};

export const TableHeaders: TableHeadersType = {
  features: [
    { field: TableField.isActive, width: 80, cellType: ECellType.Status, align: 'center' },
    { field: TableField.saveStatus, width: 10, cellType: ECellType.SaveStatus, align: 'center' },
    { field: TableField.feature, width: 180, cellType: ECellType.Feature },
    { field: TableField.option, width: 180, cellType: ECellType.Option },
    { field: TableField.type, width: 65 },
    { field: 'reset', width: 65, cellType: ECellType.Reset, align: 'center' },
  ],
  product: [
    { field: TableField.flag, width: 50, cellType: ECellType.Flag },
    { field: TableField.code, width: 150, sortable: true, align: 'center' },
    { field: TableField.country, width: 250, sortable: true, headerAlign: 'left' },
    { field: TableField.quote, width: 100, cellType: ECellType.Quote, align: 'center' },
  ],
  multiNumeric: [
    { field: TableField.code, width: 150, sort: true, searchable: true, type: ECellType.Link },
    { field: TableField.name, width: 150, sort: true, searchable: true },
    { field: TableField.isLocal, width: 100, sort: true, type: ECellType.Boolean },
    { field: TableField.isActive, width: 100, sort: true, type: ECellType.Boolean },
    { field: TableField.createdOn, width: 180, sort: true, type: ECellType.Date },
    { field: TableField.modifiedOn, width: 180, sort: true, type: ECellType.Date },
    { field: TableField.createdBy, width: 180, sort: true },
    { field: TableField.modifiedBy, width: 180, sort: true },
  ],
  allPropertiesHistory: [
    { field: TableField.propertyCode, width: 120 },
    { field: TableField.associationType, width: 145 },
    { field: TableField.featureCode, width: 120 },
    { field: TableField.optionCode, width: 120 },
    { field: TableField.action, width: 60 },
    { field: TableField.oldValue, width: 120 },
    { field: TableField.newValue, width: 120 },
    { field: TableField.createdBy, width: 200 },
    { field: TableField.createdOn, width: 200, cellType: ECellType.Date },
  ],
  propertyHistory: [
    { field: TableField.action, width: 120 },
    { field: TableField.oldValue, width: 120 },
    { field: TableField.newValue, width: 120 },
    { field: TableField.createdBy, width: 200 },
    { field: TableField.createdOn, width: 200, cellType: ECellType.Date },
  ],
};

export const searchFields = ['code', 'name'];

export const RecordLimit = {
  default: 100,
};

export const RecordLength = [
  ERecordLength.RL15,
  ERecordLength.RL25,
  ERecordLength.RL50,
  ERecordLength.RL100,
];

export const ECustomToolBar: ICustomToolBar = {
  multiNumeric: {
    search: true,
    recordsPerPage: true,
    columns: true,
    filter: true,
    refresh: true,
    delete: true,
    add: true,
    customFilterPanel: false,
  },
  allPropertiesHistory: {
    search: false,
    recordsPerPage: true,
    columns: true,
    filter: true,
    refresh: true,
    delete: false,
    add: false,
    customFilterPanel: true,
  },
  propertyHistory: {
    search: false,
    recordsPerPage: true,
    columns: true,
    filter: true,
    refresh: true,
    delete: false,
    add: false,
    customFilterPanel: true,
  },
};
